import { z } from 'zod';
import { SessionState } from '../lifecycle.js';
export const EncodingMode = z.enum(['full', 'skip-static']);
export const Resolution = z.enum(['native', '720p', '540p', '360p']);
export const Codec = z.enum(['jpeg', 'h264']);
// Capture trade-offs are picked by the VIEWER at session-create time, not
// baked into the host's config. The host is identity + behaviour only; the
// viewer tunes bandwidth / quality / smoothness per-session from their own
// browser. See apps/web/src/session/encoding-pref.ts for the UI side.
export const Fps = z.number().int().min(10).max(30);
export const JpegQuality = z.number().int().min(30).max(95);
export const SessionRequest = z.object({
    hostId: z.string().min(1),
    accessCode: z.string().nullable(),
    monitorId: z.number().int().nonnegative().nullable(),
    encoding: EncodingMode.optional(),
    resolution: Resolution.optional(),
    codec: Codec.optional(),
    fps: Fps.optional(),
    jpegQuality: JpegQuality.optional(),
});
export const SessionApprovalPrompt = z.object({
    sessionId: z.number().int().nonnegative(),
    requesterLabel: z.string(),
    requesterIp: z.string(),
    requestedAt: z.number().int().nonnegative(),
    timeoutSec: z.number().int().positive(),
});
export const SessionApprovalDecision = z.object({
    sessionId: z.number().int().nonnegative(),
    approved: z.boolean(),
    rememberDevice: z.boolean(),
});
export const SessionStarted = z.object({
    sessionId: z.number().int().nonnegative(),
    mediaUrl: z.string().min(1),
    mediaToken: z.string().min(1),
});
export const SessionStateChanged = z.object({
    sessionId: z.number().int().nonnegative(),
    state: z.enum([
        SessionState.PENDING_APPROVAL,
        SessionState.CONNECTING,
        SessionState.ACTIVE,
        SessionState.DEGRADED,
        SessionState.GRACE,
        SessionState.ENDED,
    ]),
});
export const SessionEnded = z.object({
    sessionId: z.number().int().nonnegative(),
    reason: z.string(),
});
// Defaults are a safety net - the relay forwards whatever the viewer sent on
// SessionRequest. Hosts should always receive concrete values in practice.
export const SessionMediaReady = z.object({
    sessionId: z.number().int().nonnegative(),
    mediaToken: z.string().min(1),
    encoding: EncodingMode.default('full'),
    resolution: Resolution.default('native'),
    codec: Codec.default('jpeg'),
    fps: Fps.default(20),
    jpegQuality: JpegQuality.default(75),
});
//# sourceMappingURL=session.js.map